var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1V3.5M11 1C5.47715 1 1 5.47715 1 11M11 1C16.5228 1 21 5.47715 21 11M11 18.5V21M11 21C16.5228 21 21 16.5228 21 11M11 21C5.47715 21 1 16.5228 1 11M3.5 11H1M21 11H18.5M18.0784 18.0784L16.3047 16.3047M3.92163 18.0784L5.69715 16.3029M3.92163 4L5.65808 5.73645M18.0784 4L12.4999 9.5M13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11Z",
    stroke: "#32D583",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e604e771153c0c9a10cbc7b3b5ef29f9.svg";
export { ForwardRef as ReactComponent };